import { ROUTERS } from "@/shared/constants/router";
import { useAuthStore } from "@/store/useAuth";
import { usePracticeTestIdStore } from "@/store/usePracticeTest";
import { redirect } from "@tanstack/react-router";

export function requireAuth(location: { href: string; pathname: string }) {
  const path = location.pathname as unknown as string;
  const navigation = performance.getEntriesByType(
    "navigation"
  )[0] as PerformanceNavigationTiming;

  if (
    navigation?.type !== "reload" &&
    ![ROUTERS.MOCK_TEST, ROUTERS.MOCK_TEST_RESULT].includes(path as any)
  ) {
    usePracticeTestIdStore.getState().setPracticeTestId(null);
    usePracticeTestIdStore.getState().setClassId(undefined);
  }

  if (!useAuthStore.getState().accessToken) {
    throw redirect({
      to: ROUTERS.SIGN_IN,
      search: { redirect: location.href },
    });
  }
}
